import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'pages.confirmSignUp.seoTitle',
    defaultMessage: 'Confirm Sign Up',
  },
  invalidToken: {
    id: 'pages.confirmSignUp.invalidToken',
    defaultMessage: 'Something went wrong. Please click the link in your confirmation message to try again.',
  },
  invalidTokenEmail: {
    id: 'pages.confirmSignUp.invalidTokenEmail',
    defaultMessage: 'Something went wrong. Please click the link in your confirmation email to try again.',
  },
});
